import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Button } from '@tvd/ui/button';
import { CookieConsentService } from '@tvd/data-access/cookies';

@Component({
  selector: 'tvd-cookie-consent-banner',
  imports: [Button, TranslateModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    @if (cookieConsent.hasConsent() === null) {
      <div
        class="zyn-card fixed bottom-4 max-w-[400px] shadow-xl left-1/2 -translate-x-1/2 z-[1000007] p-4"
      >
        <div class="mx-auto">
          <div class="grid gap-4">
            <div class="flex-1 text-sm ">
              <p [innerHTML]="'cookieBanner.message' | translate"></p>
            </div>
            <div class="flex gap-4 justify-between">
              <button
                zynButton
                kind="primary"
                size="sm"
                (click)="accept()"
                class="whitespace-nowrap"
                [label]="'cookieBanner.acceptAll' | translate"
                data-testid="cookie-accept-btn"
              ></button>
              <button
                zynButton
                kind="transparent"
                size="sm"
                (click)="reject()"
                class="whitespace-nowrap"
                [label]="'cookieBanner.necessary' | translate"
                data-testid="cookie-reject-btn"
              ></button>
            </div>
          </div>
        </div>
      </div>
    }
  `,
})
export class CookieConsentBanner {
  readonly cookieConsent = inject(CookieConsentService);

  accept(): void {
    this.cookieConsent.acceptAnalytics();
  }

  reject(): void {
    this.cookieConsent.rejectAnalytics();
  }
}
